import FlexCenter from "shared/components/Layout/components/FlexCenter";
import { COLOR_PRIMARY_MAIN } from "shared/theme/colors";
import OpenViewIcon from "shared/theme/icons/OpenView";
import { StyledDashboardLink } from "./styled";

type DashboardLinkProps = {
  assistantId: string;
};

const DashboardLink = ({ assistantId }: DashboardLinkProps) => {
  return (
    <FlexCenter sx={{ position: "absolute", top: "-2px", right: "0" }}>
      <StyledDashboardLink
        href={`https://platform.openai.com/playground/assistants/?assistant=${assistantId}`}
        target="_blank"
      >
        Open AI Dashboard for this Assistant
        <span>
          <OpenViewIcon color={COLOR_PRIMARY_MAIN} />
        </span>
      </StyledDashboardLink>
    </FlexCenter>
  );
};

export default DashboardLink;
